import { Component, State, Host, h } from '@stencil/core';
import { Element } from '@stencil/core';

@Component({
  tag: 'uui-storybook-tabs',
  shadow: false
})
export class UUITab {
  @State() activeTab = 0;
  @Element() el: HTMLElement;

  componentDidRender() {
    this.onTabChange(this.activeTab);
  }

  onTabChange(tabId) {
    const webComponentCodeSnippet: any = this.el.nextSibling;
    const reactCodeSnippet: any = webComponentCodeSnippet.nextSibling;

    // @ts-ignore
    const elements: HTMLElement[] = document.querySelectorAll('.sbdocs-pre');

    this.activeTab = tabId;
    // making the assumption that the web component story block is positioned first
    if (tabId === 0) {
      webComponentCodeSnippet.style.display = 'block';
      reactCodeSnippet.style.display = 'none';
    } else {
      reactCodeSnippet.style.display = 'block';
      webComponentCodeSnippet.style.display = 'none';
    }
  }

  render() {
    return (
      <Host>
        <uui-tabs>
          <uui-tab
            onClick={() => this.onTabChange(0)}
            active={this.activeTab === 0}
          >
            Web Component / Angular
          </uui-tab>
          <uui-tab
            onClick={() => this.onTabChange(1)}
            active={this.activeTab === 1}
          >
            React
          </uui-tab>
        </uui-tabs>
      </Host>
    );
  }
}
